interface BodyScrollLockState {
  activeCount: number
  previousOverflow: string
}

type BodyScrollLockGlobal = typeof globalThis & {
  __wpnBodyScrollLock?: BodyScrollLockState
}

const getBodyScrollLockState = (): BodyScrollLockState => {
  const globalScope = globalThis as BodyScrollLockGlobal
  if (!globalScope.__wpnBodyScrollLock) {
    globalScope.__wpnBodyScrollLock = {
      activeCount: 0,
      previousOverflow: '',
    }
  }
  return globalScope.__wpnBodyScrollLock
}

export const acquireBodyScrollLock = () => {
  if (!import.meta.client) return

  const state = getBodyScrollLockState()
  if (state.activeCount === 0) {
    state.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  state.activeCount += 1
}

export const releaseBodyScrollLock = () => {
  if (!import.meta.client) return

  const state = getBodyScrollLockState()
  if (state.activeCount === 0) return

  state.activeCount -= 1
  if (state.activeCount === 0) {
    document.body.style.overflow = state.previousOverflow
  }
}
